import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCustomersListItems } from "../../../../../../redux/customers/selector";
import { customers } from "../../../../../../redux/customers/action";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table-manager/v1.1/table";


const ManagementCustomers = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectCustomersListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'AccountName', headerName: 'Name', searchField: 'AccountName', sortable: true, filter: true, filterType: 'text' },
      { field: 'IsDefaultRAPCustomer', headerName: 'Default Customer', cellRenderer: 'yesNoRenderer' },
      { field: 'CreatedOnUtc', headerName: 'CreatedDate / Time', isDateValueFormat: true, },
      { field: 'ModifiedOnUtc', headerName: 'ModifiedDate / Time', isDateValueFormat: true, }
    ]);
  }
  const handleAdd = () => {
    navigate(`${0}`)
  }
  const handleEdit = (data: any) => {

    navigate(`${data?.Id}`)
  }
  const fetchCustomers = async () => {
    await dispatch(customers.resetAction({ actionType: 'list' }))
    await dispatch(customers.list({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/customers/list`, entity: 'customers', jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",


      }
    }))
  }
  const handleDelete = async (data: any) => {
    await dispatch(customers.delete({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/customers/delete`,
      entity: 'customers',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    }))
    await fetchCustomers()
  }
  useEffect(() => {
    createColumnDefs()
    fetchCustomers()
  }, [pageData, pageSize])

  const handleReloadData = () => {
    fetchCustomers()
  }
  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Customers</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "AccountName",
        FieldText: "AccountName",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(customers.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/sales/crm/logistics-customers/list`,
      entity: 'customers',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <Table
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          columnData={columnDefs}
          setPageSize={setPageSize}
          enableFilter={true}
          onSearch={handleSearch}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          headingName="Customers" />
      }
    </>

  );
};

export default ManagementCustomers;


